import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

export const getTrialDaysRemaining = (
  expirationDate: Date,
  startDate: Date = new Date()
): number => {
  if (!expirationDate) return 0;
  const differenceInDays = differenceInCalendarDays(new Date(expirationDate), startDate);
  if (differenceInDays < 0) return 0;
  return differenceInDays;
};
